import React from 'react';
import { XIcon, MinusIcon, PlusIcon, Trash2Icon } from 'lucide-react';
interface CartDrawerProps {
  isOpen: boolean;
  onClose: () => void;
}
export function CartDrawer({
  isOpen,
  onClose
}: CartDrawerProps) {
  if (!isOpen) return null;
  return <div className="fixed inset-0 z-50 flex justify-end" data-id="element-604">
      <div className="absolute inset-0 bg-slate-900/50 backdrop-blur-sm transition-opacity animate-fade-in" onClick={onClose} data-id="element-605" />

      <div className="relative w-full max-w-md bg-white h-full shadow-2xl flex flex-col animate-slide-in-right" data-id="element-606">
        {/* Header */}
        <div className="flex items-center justify-between p-6 border-b border-gray-100" data-id="element-607">
          <h2 className="font-heading text-2xl font-bold text-gray-900" data-id="element-608">
            Your Cart (2)
          </h2>
          <button onClick={onClose} className="p-2 text-gray-400 hover:text-gray-600 hover:bg-gray-100 rounded-full transition-colors" aria-label="Close cart" data-id="element-609">
            <XIcon className="w-6 h-6" data-id="element-610" />
          </button>
        </div>

        {/* Cart Items */}
        <div className="flex-1 overflow-y-auto p-6 space-y-6" data-id="element-611">
          {/* Item 1 */}
          <div className="flex gap-4" data-id="element-612">
            <div className="w-24 h-24 bg-brand-blue-50 rounded-xl flex items-center justify-center flex-shrink-0" data-id="element-613">
              <div className="w-10 h-10 bg-brand-blue-200 rounded-full" data-id="element-614" />
            </div>
            <div className="flex-1 flex flex-col" data-id="element-615">
              <div className="flex justify-between items-start" data-id="element-616">
                <h3 className="font-heading font-semibold text-gray-900 text-sm line-clamp-2 pr-4" data-id="element-617">
                  Royal Canin Medium Adult Dry Dog Food 15kg
                </h3>
                <button className="text-gray-400 hover:text-red-500 transition-colors" data-id="element-618">
                  <Trash2Icon className="w-4 h-4" data-id="element-619" />
                </button>
              </div>
              <div className="text-brand-blue font-bold mt-1" data-id="element-620">$109.99</div>

              <div className="flex items-center gap-3 mt-auto pt-2" data-id="element-621">
                <div className="flex items-center border border-gray-200 rounded-lg" data-id="element-622">
                  <button className="p-1.5 text-gray-500 hover:bg-gray-50 rounded-l-lg" data-id="element-623">
                    <MinusIcon className="w-4 h-4" data-id="element-624" />
                  </button>
                  <span className="w-8 text-center text-sm font-medium" data-id="element-625">1</span>
                  <button className="p-1.5 text-gray-500 hover:bg-gray-50 rounded-r-lg" data-id="element-626">
                    <PlusIcon className="w-4 h-4" data-id="element-627" />
                  </button>
                </div>
              </div>
            </div>
          </div>

          {/* Item 2 */}
          <div className="flex gap-4" data-id="element-628">
            <div className="w-24 h-24 bg-brand-green-50 rounded-xl flex items-center justify-center flex-shrink-0" data-id="element-629">
              <div className="w-10 h-10 bg-brand-green-200 rounded-full" data-id="element-630" />
            </div>
            <div className="flex-1 flex flex-col" data-id="element-631">
              <div className="flex justify-between items-start" data-id="element-632">
                <h3 className="font-heading font-semibold text-gray-900 text-sm line-clamp-2 pr-4" data-id="element-633">
                  Seasol Liquid Fertiliser 2L
                </h3>
                <button className="text-gray-400 hover:text-red-500 transition-colors" data-id="element-634">
                  <Trash2Icon className="w-4 h-4" data-id="element-635" />
                </button>
              </div>
              <div className="text-brand-blue font-bold mt-1" data-id="element-636">$24.95</div>

              <div className="flex items-center gap-3 mt-auto pt-2" data-id="element-637">
                <div className="flex items-center border border-gray-200 rounded-lg" data-id="element-638">
                  <button className="p-1.5 text-gray-500 hover:bg-gray-50 rounded-l-lg" data-id="element-639">
                    <MinusIcon className="w-4 h-4" data-id="element-640" />
                  </button>
                  <span className="w-8 text-center text-sm font-medium" data-id="element-641">2</span>
                  <button className="p-1.5 text-gray-500 hover:bg-gray-50 rounded-r-lg" data-id="element-642">
                    <PlusIcon className="w-4 h-4" data-id="element-643" />
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Footer */}
        <div className="border-t border-gray-100 p-6 bg-warm-50" data-id="element-644">
          <div className="flex justify-between items-center mb-4" data-id="element-645">
            <span className="text-gray-600 font-medium" data-id="element-646">Subtotal</span>
            <span className="font-heading text-2xl font-bold text-gray-900" data-id="element-647">
              $159.89
            </span>
          </div>

          <div className="space-y-3 mb-6" data-id="element-648">
            <div className="bg-brand-blue-50 text-brand-blue-800 text-sm p-3 rounded-lg flex items-start gap-2" data-id="element-649">
              <span className="font-bold mt-0.5" data-id="element-650">ⓘ</span>
              <p data-id="element-651">
                Free local delivery on eligible orders over $100 within 5km.
              </p>
            </div>
            <div className="bg-warm-100 text-gray-700 text-sm p-3 rounded-lg flex items-start gap-2" data-id="element-652">
              <span className="font-bold mt-0.5" data-id="element-653">ⓘ</span>
              <p data-id="element-654">
                Items subject to store availability. We'll confirm your order.
              </p>
            </div>
          </div>

          <div className="space-y-3" data-id="element-655">
            <button className="btn-primary w-full py-4 text-lg" data-id="element-656">
              Proceed to Checkout
            </button>
            <button className="btn-secondary w-full py-3" onClick={onClose} data-id="element-657">
              Continue Shopping
            </button>
          </div>

          <div className="mt-6 flex items-center justify-center gap-2 text-sm text-gray-500 font-medium" data-id="element-658">
            <span className="w-2 h-2 rounded-full bg-brand-blue" data-id="element-659"></span>
            Proudly WA Owned & Operated
          </div>
        </div>
      </div>
    </div>;
}